import { EditorState } from 'draft-js';

export default (editorState, selection) => {
    const updatedEditorState = EditorState.acceptSelection(editorState, selection);
    return EditorState.forceSelection(updatedEditorState, selection);
};
